
export default {
  Close: '閉じる',
  Confirm: '確認',
  header: {
    Home: 'ホームページ',
    MyOrder: '注文履歴',
    Login: 'ログイン',
    changeYourPassword: 'パスワード変更',
    logout: '終了'
  },
  Announcement: '情報',
  WeChatTitle: '秦始皇帝陵博物院WeChat公式アカウント',
  PleaseUseWeChat: 'WeChatで上の公式アカウントのQRコードをスキャンしてください',
  CountDown: 'カウントダウン',
  CountDownComplete: 'クローズ',
  buyTicket: {
    selectAVisitDate: '日時を選びます',
    selectAVisitTime: '入場の期間を選びます',
    selectTicketType: 'チケット種別を選びます',
    maxNum: `一つの注文で最大&valItem枚のチケットを買えます`,
    Monday: '月曜日',
    Tuesday: '火曜日',
    Wednesday: '水曜日',
    Thursday: '木曜日',
    Friday: '金曜日',
    Saturday: '土曜日',
    Sunday: '日曜日',
    notBooking: '予約不可',
    ticketBalance: '残り',
    productName: '製品名',
    ticketType: 'チケット種別',
    ticketingInstructions: 'チケット情報',
    PleaseRead: '利用規約を詳しく読でください',
    IRead: '詳しく読みました。引き続き予約します',
    UnitPrice: '単価',
    Quantity: '数量',
    noDataAvailable: '該当するデータはございません',
    telephoneConsultation: '電話お問い合わせ',
    onlineConsultation: 'オンラインお問い合わせ',
    weChatOfficialAccount: 'WeChat公式アカウント',
    Reminder: '指示メッセージ',
    totalPrice: '総額',
    placeOrder: '注文する',
    ticketingInstructions: 'チケット情報',
    Total: '合計',
    totalNum: '合計&valItem枚',
    TotalPrice: '総額',
    LatestAnnouncement: '最新情報',
    viewMore: 'もっと見る'
  },
  // 购票进程
  TicketingProcessObj: {
    TicketingProcess: 'チケット購入プロセス',
    TimeOut: '入場の期間を選びます',
    selectTicketType: 'チケット種別を選びます',
    FillOrder: '注文情報を入力します',
    OrderPayment: '注文支払いします',
    Completed: '完成'
  },
  // 账号密码登录注册修改
  LoginObj: {
    LoginAndPassword: 'アカウントパスワードログイン',
    LoginCode: '検証コードログイン',
    PleaseNumber: '携帯電話番号を入力してください',
    PleasePassword: 'パスワードを入力してください',
    Change: 'チェンジ',
    PleaseCode: '検証コードを改めて入力してください',
    PleaseAgain: 'パスワードを改めて入力してください',
    LogIn: '今すぐログイン',
    SignUpNow: '今すぐ新規作成',
    ForgotPassword: 'パスワードを忘れた場合',
    AgreeDisclaimer: '利用規約と免責事項に同意します',
    GetVerificationCode: '認証コード取得',
    Reacquire: '再取得',
    NoAccount: 'アカウントがありません',
    ChangePassword: 'パスワード変更',
    Logout: '終了',
    ExistingAccount: '已有账号',
    ImmediatelyFind: '立即找回'
  },
  // 下单页
  FillOrder: {
    FillOrder: '注文情報を入力します',
    FillOrderTitle: '秦始皇帝陵博物院のチケット購入は実名制を実施しており、すべての観客は身分情報を入力して予約することができます',
    VisitDate: '入場日時',
    Name: '姓名',
    DocumentType: '証明書タイプ',
    IDCard: '身分証明書',
    Passport: 'パスポート',
    Others: 'その他',
    IDNumber: '証明書番号',
    SpecialIDType: '特殊証明書タイプ',
    SpecialIDNumber: '特殊証明書番号',
    DeleteThisContact: 'この連絡先を削除します',
    PleaseYourName: '姓名を入力してください',
    PleaseIDNumber: '証明書番号を入力してください',
    PleaseSpecialIDNumber: '特殊証明書番号を入力してください',
    PleaseenterContact: '連絡先の携帯電話番号を入力してください',
    Delete: '削除します',
    information: '連絡先の情報',
    informationSub: '（注文情報を受け取ることができないように、正確に記入してください）',
    ContactPhoneNumber: '携帯電話番号',
    TotalAmount: '総額',
    BuyNow: '今すぐ購入',
    ConfirmReminder: '確認済み',
    DoubleConfirm: '再確認',
    Confirmed: '確認済み',
    BeforeBy: 'すぐ購入する前に、見学体験に影響を与えないように、身分情報が正しく入力されているかどうかを確認してください。',
    OutByOrder: 'ご注意',
    Mausoleum: 'ようこそ秦始皇帝陵博物院へ！ご注意：毎日のシステムメンテナンス時間は23：30から翌日02：30までで、その間でチケット販売サービスを一時停止します。',
    Reminder: '指示メッセージ',
    PleaseCorrectInformation: '正しい情報を入力してください',
    AgeDiscountRange: 'あなたの年齢は割引範囲内ではありません',
    InvalidIDNumber: '身分証明書番号無効',
    productName: '製品名',
    ticketType: 'チケット種別',
    Quantity: '数量',
    UnitPrice: '単価'
  },
  back: '戻る',
  // 支付
  payOrder: {
    OrderQuantity: '注文数',
    NumberProducts: '商品数',
    OrderInformation: '注文情報',
    VisitTime: '入場日時',
    TicketName: 'チケット名称',
    ticketType: 'チケット種別',
    UnitPrice: '単価',
    Quantity: '数量',
    PaymentOrderSeconds: '注文支払いの残り時間:&item1分&item2秒',
    PleaseComplete: '時間内に完了してください。そうでない場合、注文は自動的にキャンセルされます',
    Alipay: 'アリペイ',
    WeChat: 'WeChat',
    PleaseQRcodepay: 'QRコードをスキャンして支払ってください',
    Orderpaymenttimeout: '注文支払いがタイムアウトしましたので、再注文してください！',
    goFillOrderL: '注文に行く',
    Backtohome: 'ホームページに戻る',
    Checkorder: '注文を確認する',
    Refund: '払戻し',
    TicketReplacement: 'チケットを改めて買う',
    ChangeTicket: 'チケット変更',
    RefundProgress: '払戻し中'
  },
  Cancel: 'キャンセル',
  Backtohome: 'ホームページに戻る',
  Checkorder: '注文を確認する',
  LatestAnnouncement: '最新情報',
  PreviousPage: '前のページ',
  NextPage: '次のページ',
  ReleaseTime: '発表時間',
  MyOrder: {
    MyOrder: '注文履歴',
    OrderCenter: '注文センター',
    All: 'すべて',
    Completed: '完成済み',
    ToBePaid: '支払い待ち',
    OrderNumber: '注文番号',
    VisitorIDNumber: '旅行人証明書番号',
    Inquire: 'チェック',
    Reset: 'リセット',
    OrderPlacementTime: '注文時間',
    Contactphonenumber: '連絡先の携帯電話番号',
    OrderStatus: '注文状態',
    Startdate: '開始日',
    EndDate: '終了日',
    VisitTime: '入場日時',
    Visitdate: '旅行期日',
    VisitTimePeriod: '入場時間',
    Actualpaymentpaymentmethod: '実費/支払い方法',
    Operating: '操作',
    OrderDetails: '注文詳細',
    Paymentquery: '支払いチェック',
    Expandall: 'すべてを展開',
    CreationDate: '作成時間',
    Fullorderamount: '注文全額',
    Fullpayment: '実払い全額',
    Fullrefund: '払戻し全額',
    Handlingfee: '手数料',
    Ticketnumber: 'チケット番号',
    TicketcheckingQRcode: '改札QRコード',
    Effectivedate: '有効期間',
    Effectivetime: '有効時間',
    Numberofpeople: '人数',
    Numberoftimes: '回数',
    Ticketcollectiondate: 'チェック受け取り期日',
    Numberofprints: '印刷回数',
    Numberofticketschecked: '検査済み回数',
    Ticketstatus: 'チェック状態',
    Checkingrecords: '改札記録',
    Uncollectedticket: '未取チェック受け取り待ち票',
    Void: '無効',
    Checkinrecords: '改札記録',
    Close: '閉じる',
    Checkininformation: '改札情報',
    Ticketidentificationnumber: '改札識別番号',
    Checkindate: '改札期日',
    Checkintime: '改札時間',
    Checkpointname: '改札名',
    Nodataavailable: 'データない',
    Price: '価格',
    Handlingfee: '手数料',
    selectText: '&item1枚選びました，合計',
    selectText2: '手数料',
    selectVisitTime: '見学時間を選択してください'
  },
  orderStatus: {
    Pendingreview: '審査待ち',
    Closed: '閉じました',
    Issued: '振り出し済み',
    Tobepaid: '支払い待ち',
    Refunded: '払戻し済み',
    Completed: '完成済み'
  },
  status: '状態',
  Ticketcollectionstatus: 'チェック受け取り状態',
  Pickedup: 'チェック受け取り済み',
  NotPickup: 'チェック受け取り待ち',
  Ticketcheckintype: '改札類型',
  Normalticketcheckin: '正常改札',
  Freeadmissionticketcheckin: '無料改札',
  Mandatoryticketcheckin: '強制改札',
  Ticketcheckmedia: '改札媒質',
  Ticketidentificationnumber: '改札識別番号',
  Checkindate: '改札期日',
  Checkintime: '改札時間',
  Checkpointname: '改札名',
  el: {
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共{total}条',
      pageClassifier: '页'
    }
  }
}
